import type { ComponentType, ReactNode } from "react";

export interface IBreadcrumbs {
  levels?: ReactNode[];
}

export const Breadcrumbs: ComponentType<IBreadcrumbs> = () => {
  return null;
  // const { levels = [] } = props;
  // return (
  //   <Breadcrumb style={{ display: "none" }}>
  //     {/*<BreadcrumbItem active={levels.length === 0}>*/}
  //     {/*{levels.length === 0 ? <DashboardLabel /> : <Link to="/"><DashboardLabel /></Link>}*/}
  //     {/*</BreadcrumbItem>*/}
  //     {levels &&
  //       levels.map((level, index) => {
  //         return (
  //           <BreadcrumbItem key={index} active={levels.length - 1 === index}>
  //             {level}
  //           </BreadcrumbItem>
  //         );
  //       })}
  //   </Breadcrumb>
  // );
};

export default Breadcrumbs;
